<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <!--<div class="col-sm-2 ">
                        </div>-->
                        <div class="col-sm-12 card bg-light">
                            <div v-if="loading" class="spinner__icon spinner__icon--xxlarge spinner_position">
                            </div>
                            <h4 class="mb-4">User Creation</h4>
                            <div class="panelDiv">
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <label class="control-label font-bold" for="email">Email  *</label>
                                        </div>
                                        <div class="col-sm-5 ">
                                            <input type="text" class="form-control border input-control-border" id="email" v-model="email" placeholder="Enter email" name="email" v-validate="{required: true, regex:/^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(ey)\.com$/}" :class="{'is-invalid':errors.has('email')}">
                                            <span v-show="errors.has('email')" class="text-danger">Please enter valid Email</span>
                                        </div>
                                        <div class="col-sm-4">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <label class="control-label font-bold" for="applications">Applications </label>
                                        </div>
                                        <div class="col-sm-7 ">
                                            <div v-for="(appdetails, index) in AppList.applications" v-bind:key="index.id" class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="checkbox" class="form-check-input checkmark" style="cursor: pointer;" v-bind:id="'chk' + appdetails.id" v-on:click="handleChkEvent($event,appdetails.id)" :value="appdetails.name">{{appdetails.name}}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <label class="control-label font-bold" for="isAdmin">Is Admin  </label>
                                        </div>
                                        <div class="col-sm-5 ">
                                            <div class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="checkbox" class="form-check-input checkmark" style="cursor: pointer;" v-model="isAdmin">
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col text-center">
                                        <button class="btn btn-primary" v-on:click="Invite" :disabled="errors.any()">Invite</button>
                                    </div>
                                </div>
                                <br />
                                <!--<div v-if="showStatusAlert" class="alert alert-danger alert-dismissible fade show col-sm-8">
                                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                                    <strong> {{this.statusMessage}} </strong>
                                </div>-->
                                <div v-if="showStatusAlert" class="col-sm-6 alert" style="margin-left:20px;box-shadow:  0 0 1rem 0 rgba(0,0,0,.2);">
                                    <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="icon exclamationCircle" style="width:16px;height:16px;color:#b9251c;" />
                                    &nbsp;&nbsp; {{this.statusMessage}}
                                </div>
                                <!--<div v-if="showStatusSuccess" class="alert alert-success alert-dismissible fade show col-sm-8">
                                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                                    <strong> {{this.statusMessage}} </strong>
                                </div>-->
                                <div v-if="showStatusSuccess" class="col-sm-6 alert" style="margin-left:20px;word-wrap: break-word;box-shadow: 0 0 1rem 0 rgba(0,0,0,.2);">
                                    <font-awesome-icon :icon="['fas', 'check-circle']" class="icon check" style="width:16px;height:16px;color:#168736;" />
                                    &nbsp;&nbsp;{{this.statusMessage}}
                                </div>
                            </div>
                        </div>
                        <!--<div class="col-sm-2 ">
                        </div>-->
                    </div>
                    <div class="row" style="margin-top:30px;">
                        <!--<div class="col-sm-2 ">
                        </div>-->
                        <div class="col-sm-12 card bg-light">
                            <h4 class="mb-4">User Application Permission</h4>
                            <div class="panelDiv">
                                <div class="container">
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="container">
                                        <div class="row col-sm-12">
                                            <div class="col">
                                                <table id="user-table"
                                                       class="table table-striped display table-bordered"
                                                       cellspacing="0"
                                                       width="100%">
                                                    <thead>
                                                        <tr>
                                                            <th>User Name</th>
                                                            <th>Full Name</th>
                                                            <th>Applications</th>
                                                            <th>Role</th>
                                                            <th>Status</th>
                                                            <th>Created On</th>
                                                            <th>Created By</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody></tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import LoginService from '../../services/login.service.js';
    import CommonService from '../../services/SharedService/common.service.js'
    import Algorithm from "../../services/Algorithm.js";
    import { EnvironmentConfig } from '../../services/constants.js';
    import $ from 'jquery';
    export default {
        name: 'UserCreation',
        data() {
            return {
                email: '',
                isAdmin: false,
                AppList: [],
                appNames: '',
                showStatusAlert: false,
                showStatusSuccess: false,
                statusMessage: '',
                dataTable: null,
                userDetails: [],
                loading: false,
                emailregex: '/^[0-9]+$/'
            }
        },
        mixins: [LoginService, CommonService, Algorithm],
        created() {
            this.loading = true;
            this.GetApplicationList();
        },
        methods: {
            GetApplicationList() {
                // var token = localStorage.getItem('adal.idtoken');
                this.AppList = JSON.parse(sessionStorage.getItem('appList'));
            },
            Invite() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.loading = true;
                        var jsonInvite =
                        {
                            //"FromAddress": "EY_DTC_Prod_Support_App.GID@ey.net",
                            "ToAddress": this.email,
                            "Subject": "Access link for DTC Application",
                            //"Body": '&#60;html&#62;&#60;body&#62;Hello there,&#60;br&#62;&#60;br&#62;Welcome to the Direct Tax Compliance Project.&#60;br&#62;Please ' + '&#60;a clicktracking=off href="' + window.location.origin + '/RegisterUser"&#62;Click here&#60;/a&#62; ' + ' to access DTC Application.&#60;br&#62;If you are not able to access above link, then copy & paste the URL  "' + window.location.origin + '/RegisterUser" in the browser directly. &nbsp;&#60;br&#62;&#60;br&#62;&#60;strong&#62;Thanks&#60;/strong&#62;&#60;br&#62;&#60;strong&#62;DTC Support Team &#60;/strong&#62;&#60;/body&#62;&#60;/html&#62;',
                            "IsHTMLBody": true,
                            "UserDetail": {
                                "Email": this.email,
                                "AppIds": this.appNames,
                                "Role": this.isAdmin,
                                "FirstName": localStorage.getItem('firstName'),
                                "LastName": localStorage.getItem('lastName'),
                                "UserId": localStorage.getItem('userId')
                            }
                        };
                        this.UserApplicationPermission(jsonInvite).then(Response => {
                            if (Response.data) {
                                this.statusMessage = Response.data;
                                if (this.statusMessage == 'Saved Successfully') {
                                    this.loading = false;
                                    this.showStatusAlert = false;
                                    this.showStatusSuccess = true;

                                    ////                                    
                                    var table = this.dataTable;
                                    this.GetUserDetails().then(response => {
                                        if (response) {
                                            this.userDetails = response.data;
                                            this.userDetails.forEach(userDetailsItems => {
                                                table.columns.adjust().draw();
                                                table.row
                                                    .add([userDetailsItems.email, userDetailsItems.userName, userDetailsItems.appName, userDetailsItems.role, userDetailsItems.status, userDetailsItems.createdOn, userDetailsItems.createdBy])
                                                    .draw(false);
                                            });
                                            this.loading = false;
                                        }
                                    });
                                    ////

                                }
                                else {
                                    this.loading = false;
                                    this.showStatusSuccess = false;
                                    this.showStatusAlert = true;
                                }
                            }
                        });
                    }
                })
            },
            handleChkEvent(e, appId) {
                var appPermission = e.target.checked;
                if (appPermission == true) {
                    if (this.appNames == '') {
                        this.appNames = appId;
                    }
                    else {
                        this.appNames = this.appNames + ',' + appId;
                    }
                }
                if (appPermission == false) {
                    var elements = this.appNames.split(",");
                    var remove_index = elements.indexOf(appId);
                    elements.splice(remove_index, 1);
                    this.appNames = elements.join(",");
                }
            }
        },
        mounted() {
            this.dataTable = $("#user-table").DataTable({
                pageLength: 50,
                scrollY: "80%",
                scrollX: "80%",
                scrollCollapse: true,
                columnDefs: [
                    { width: '25%', targets: 0 }
                ],
                fixedColumns: true
            });
            var table = this.dataTable;
            this.GetUserDetails().then(response => {
                if (response) {
                    this.userDetails = response.data;
                    this.userDetails.forEach(userDetailsItems => {
                        table.columns.adjust().draw();
                        table.row
                            .add([userDetailsItems.email, userDetailsItems.userName, userDetailsItems.appName, userDetailsItems.role, userDetailsItems.status, userDetailsItems.createdOn, userDetailsItems.createdBy])
                            .draw(false);
                    });
                    this.loading = false;
                }
            });
        }
    }
</script>
<style scoped>
    .custom-control {
        background-color: red;
    }

    table.dataTable th:nth-child(4),
    table.dataTable th:nth-child(5),
    table.dataTable th:nth-child(7) {
        width: 75px;
        max-width: 80px;
        word-break: break-all;
        white-space: pre-line;
    }

    table.dataTable td:nth-child(4),
    table.dataTable td:nth-child(5),
    table.dataTable td:nth-child(7) {
        width: 75px;
        max-width: 80px;
        word-break: break-all;
        white-space: pre-line;
    }
</style>